import React, { useState } from "react";
import {
  Button,
  Carousel,
  CarouselIndicators,
  CarouselItem,
  CarouselItems,
  Marker,
} from "@kaena1/mm-ui-components";
import { useMediaQuery } from "@kaena1/mm-ui-hooks";
import { ProfileVideoCard } from "./components/ProfileVideoCard";
import { VideoPlayerModal } from "./components/VideoPlayerModal";
import "./css/video-testimonials.scss";

const cardsInfo = [
  {
    name: "Jackie",
    title: "The professional",
    text: "I’ve only found that I have really good service at a much lower price tag. Yeah it kinda seems too good to be true and I’m wondering what the catch is, but it really is that great of a service.",
    image: "/wp-content/themes/mintmobile/v3/assets/images/reviews/video-testimonials/the-professional.jpg",
    videoId: "28sK2UGecDI",
  },
  {
    name: "Blue",
    title: "The parent",
    text: "So I was looking into Mint, I was thinking like, “Okay, what’s the catch?” Like there’s gotta be something wrong with it, but it really is as good as it looks.",
    image: "/wp-content/themes/mintmobile/v3/assets/images/reviews/video-testimonials/the-parent.jpg",
    videoId: "Q-4Ppbt9oy0",
  },
  {
    name: "Michael",
    title: "The traveler",
    text: "When I heard about Mint, I thought it was too good to be true… My service with Mint has been incredible.",
    image: "/wp-content/themes/mintmobile/v3/assets/images/reviews/video-testimonials/the-traveler.jpg",
    videoId: "nsrSPXzOM7Q",
  },
  
  {
    name: "Tatiana",
    title: "The saving expert",
    text: "I think i was expecting for it to be like a lower tier service because of the price but it was operating exactly the same, if not better, than my previous carriers.",
    image: "/wp-content/themes/mintmobile/v3/assets/images/reviews/video-testimonials/the-saving-expert.jpg",
    videoId: "eBtn-XMgpx8",
  },
];

export const VideoTestimonials = () => {
  const [videoId, setVideoId] = useState<string | null>(null);
  const desktopVersion = useMediaQuery("(min-width: 1024px)");

  return (
    <div className="testimonials">
      <div className="videoContainer">
        {videoId && (
          <VideoPlayerModal videoId={videoId} setVideoId={setVideoId} />
        )}
        {desktopVersion ? (
          <div className="desktopCardsContainer">
            {cardsInfo.map((cardInfo, index) => (
              <div key={index}>
                <ProfileVideoCard
                  {...cardInfo}
                  onClick={() => setVideoId(cardInfo.videoId)}
                />
              </div>
            ))}
          </div>
        ) : (
          <Carousel>
            <CarouselItems>
              {cardsInfo.map((cardInfo, index) => (
                <CarouselItem key={index} label={`slide-${index + 1}`}>
                  <ProfileVideoCard
                    {...cardInfo}
                    onClick={() => setVideoId(cardInfo.videoId)}
                  />
                </CarouselItem>
              ))}
            </CarouselItems>
            <CarouselIndicators
              className="carouselNav"
              indicator={(active: boolean) => <Marker active={active} />}
            />
          </Carousel>
        )}
      </div>
      <Button
        variant="secondaryPill"
        href="/is-mint-mobile-good"
        className="button"
      >
        View More Testimonials
      </Button>
    </div>
  );
};